import React from "react";
import {
  Badge,
  Button,
  CloseButton,
  Container,
  Flex,
  TextInput,
  Title,
  Accordion,
} from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { FormValues } from "./ProfileEdit";

interface RoleSectionProps {
  form: UseFormReturnType<FormValues>;
}

const EditRoleSection: React.FC<RoleSectionProps> = ({ form }) => {
  const [addRole, setAddRole] = React.useState("");

  return (
    <Container size="md" pt={50}>
      <Accordion
        chevronPosition="left"
        defaultValue="roles"
        styles={{
          item: {
            // styles added to all items
            borderRadius: "15px",
            backgroundColor: "#f1f2f4",
            border: `none`,

            // styles added to expanded item
            "&[data-active]": {
              backgroundColor: "#f1f2f4",
            },
            "&:hover": {
              backgroundColor: "#f1f2f4",
            },
          },
          control: {
            borderRadius: "15px",
            "&:hover": {
              backgroundColor: "#f1f2f4",
            },
            svg: {
              width: "2rem",
            },
          },
        }}
      >
        <Accordion.Item value="roles">
          <Flex>
            <Accordion.Control>
              <Title size="h1" fw={300} mb={20} color={"#3e4066"}>
                Roles
              </Title>
            </Accordion.Control>
            <Flex align="center" mr={30}>
              <Flex>
                <TextInput
                  placeholder="Add role"
                  radius="md"
                  label=""
                  value={addRole}
                  w={315}
                  mr={10}
                  mb={20}
                  onChange={(e) => setAddRole(e.currentTarget.value)}
                />
                <Button
                  onClick={() => {
                    form.insertListItem("roles", addRole);
                    setAddRole("");
                  }}
                  disabled={!addRole}
                >
                  Add
                </Button>
              </Flex>
            </Flex>
          </Flex>
          <Accordion.Panel>
            {form.values.roles.map((item, index) => (
              <Badge
                key={`${item} ${index}`}
                color="green"
                size="xl"
                variant="filled"
                mr={10}
                mb={10}
                pt={20}
                pb={20}
                sx={{
                  color: "#3e4066",
                  textTransform: "capitalize",
                  backgroundColor: "#ADFCA2",
                  fontWeight: 500,
                  minWidth: "100px",
                }}
                rightSection={
                  <CloseButton
                    aria-label="Delete item"
                    mr={-10}
                    color="dark"
                    onClick={() => form.removeListItem("roles", index)}
                  />
                }
              >
                {item}
              </Badge>
            ))}
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
};

export default EditRoleSection;
